export default __webpack_public_path__ + "static/media/process_06.ba4da5a7.png";